// @ts-nocheck
import Vue from 'vue';
import Vuex from 'vuex';
import type = Mocha.utils.type;
import set = Reflect.set;
import Axios from 'axios'
import i18n from '.././i18n'

const tickerMaxRealTimeBets = 100;
Vue.use(Vuex);
let wsConnection = {};
let liabilityTimeout = null;
function s2ab(s) {
  let buf = new ArrayBuffer(s.length);
  let view = new Uint8Array(buf);
  for (let i = 0; i != s.length; ++i) view[i] = s.charCodeAt(i) & 0xFF;
  return buf;
}

function b64EncodeUnicode(str) {
  // first we use encodeURIComponent to get percent-encoded UTF-8,
  // then we convert the percent encodings into raw bytes which
  // can be fed into btoa.
  return btoa(encodeURIComponent(str).replace(/%([0-9A-F]{2})/g,
    function toSolidBytes(match, p1) {
      return String.fromCharCode('0x' + p1);
    }));
}

function b64DecodeUnicode(str) {
  // Going backwards: from bytestream, to percent-encoding, to original string.
  return decodeURIComponent(atob(str).split('').map(function (c) {
    return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
  }).join(''));
}

export default new Vuex.Store({
  state: {
    alertMessage:null,
    initialStateReady: false,
    isMobile: false,
    user: {
      token:null,
      isLoggedIn: false,
      minimumLiability: 1,
      isTrader: false,

      info: {
        balance: 0,
        country: "",
        currency: "",
        email: "",
        language: "",
        partner: "",
        partnerUserId: "",
        refreshToken: "",
        token: "",
        userId: ""
      }
    },
    backendConnectionEstablished: true,
    isInLockdown:false,
    feedIsOnline: true,
    feedStatus:{
      list:[]
    },
    appIsOnline: true,
    deviceMode: 'mobile',
    userCurrency: '$',
    lastReceivedUpdate: null,
    serverStatus: 'Disconnected',
    markets: {},
    streamMappings: [],
    streamMappingsObj: {},
    liveCenter: {
      eventsWithStreamId: {},
      selectedEvent: 'none',
      currentView: 'lmt',

      streamInfo: {
        videoError: 'none',
        rid: '',
        streamId: '',
        hlsUrl: 'unset',
        dashUrl: 'unset'
      }
    },
    bets: {
      shouldRefocus: true,
      betsOpenPosition: {},
      activeSection: 'betslip',
      betslip: {
        calculatedLiability: null,
        isCalculatingLiability: false,
        isPlacingBets: false,
        message: {
          type: '',
          message: '',
          messagePersistence: ''
        },
        betMessages: {},
        newestBet: '',
        betList: [],
        backBets: [],
        layBets: []
      },
      active: {
        batchCounter: 0,
        eventsWithBets: {},
        isUpdatingBets: false,
        // message: {
        //   type: '',
        //   message: '',
        //   messagePersistence: ''
        // },
        selectedFilter: 'all',
        betMessages: {},
        // betBeingUpdated: {},
        betsBeingUpdated: {},
        betsBeingDeleted:{},
        openBets: {},
      },
      settled: {
        betsList: [],
        timeSelectedFrom: '',
        timeSelectedTo: '',
        isLoading: false
      }
    },
    trader: {
      shouldRefocus: true,
      betsOpenPosition: {},
      activeSection: 'ticker',
      bettingBot: {
        openBettingBotMobileToggler: false,
        message: {
          type: '',
          message: '',
          messagePersistence: ''
        },
        bettingBotResetFlags: false,
        selectedSport: '',
        selectedCategory: '',
        selectedTournament: '',
        selectedMarket: 'none',
        supportedSports: [],
        supportedSportsMap: {},
        marketsForBot: {},
        marketsForTournament: {}
      },
      ticker: {
        tickerMaxRealTimeBets: tickerMaxRealTimeBets,
        isFetchingHistoricalBets: false,
        historyHasMoreBets: true,
        tickerIsFrozen: false,
        tickerBetsOnHold: [],
        selectedCategoryOfBets: 'allBets',
        selectedSport: 'all',
        selectedMinStake: 'none',
        tickerBets: [],
        tickerBetsHistorical: [],
      },
      settledMarkets: {
        isDownloading:false,
        from: '',
        to: '',
        settledMarketsList: [],
        isLoading: false
      },
    },
    events: {
      eventsList: {totalEvents: 0},
      eventsListLiveFlat: [],
      eventsVolumeUnpaired:{}
    },
    navigations: {
      shouldDetachBets: false,
      mobileDialogPayloads: {
        category: 'none',
        tournament: 'none'
      },
      timeframe: 'all',
      isChoosingLeaguesMobile: false,
      selectedTournament: 'none',
      selectedCategory: 'none',
      selectedSport: "none",
      selectedEvent: 'none',
      selectedSportData: 'none',
      selectedSportCountries: [],
      selectedSportTopTournaments: [],
      selectedSportTopCategories: [],
      sports: [],

    }
  },
  mutations: {
    setAlertMessage:function (state,payload){
      state.alertMessage = payload
    },
    setIsDownloadingReport:function(state,payload){
      state.trader.settledMarkets.isDownloading = payload;
    },
    incrementOpenBetsBatchCounter: function (state, payload) {
      state.bets.active.batchCounter++
    },
    setCalculatedLiability: function (state, payload) {
      state.bets.betslip.calculatedLiability = payload;
    },
    setIsCalculatingLiability: function (state, payload) {
      state.bets.betslip.isCalculatingLiability = payload;
    },
    //ticker
    setTickerHasMoreBets: function (state, payload) {
      state.trader.ticker.historyHasMoreBets = payload
    },
    lockTickerBetFetching: function (state, payload) {
      state.trader.ticker.isFetchingHistoricalBets = true;
    },
    unlockTickerBetFetching: function (state, payload) {
      state.trader.ticker.isFetchingHistoricalBets = false;
    },
    setTickerBetEntries: function (state, payload) {
      state.trader.ticker.tickerBetsHistorical = state.trader.ticker.tickerBetsHistorical.concat(payload)
    },
    clearOnHoldBets: function (state, payload) {
      state.trader.ticker.tickerBetsOnHold = []
    },
    clearTickerBets: function (state, payload) {
      state.trader.ticker.tickerBets = []
      state.trader.ticker.tickerBetsHistorical = []
    },
    setSelectedMinStake: function (state, payload) {
      state.trader.ticker.selectedMinStake = payload;
    },
    setSelectedCategoryOfBets: function (state, payload) {
      state.trader.ticker.selectedCategoryOfBets = payload;

    },
    setSelectedSportForTicker: function (state, payload) {
      state.trader.ticker.selectedSport = payload;

    },
    setTickerIsFrozen: function (state, payload) {
      state.trader.ticker.tickerIsFrozen = payload
    },
    batchedAddTickerBets: function (state, bulkPayload) {
      bulkPayload.forEach(function (payload) {
        let shouldCommit = true;
        let selectedCategory = state.trader.ticker.selectedCategoryOfBets;

        if (state.trader.ticker.selectedSport !== 'all' && state.trader.ticker.selectedSport.sportIdentifier !== payload.sportIdentifier) {
          shouldCommit = false;

        }
        if (state.trader.ticker.selectedMinStake !== 'none' && state.trader.ticker.selectedMinStake > payload.stakeUSD) {
          shouldCommit = false;

        }
        if (selectedCategory !== 'allBets') {
          if (selectedCategory === 'botsBets'
            && (payload.backFromBot === false && payload.layFromBot === false)) {
            shouldCommit = false;

          } else if (selectedCategory === 'betweenUsers' && (payload.backFromBot === true || payload.layFromBot === true)) {
            shouldCommit = false;

          } else if (selectedCategory === 'selectedEventAllBets' &&
            state.navigations.selectedEvent.id !== payload.eventId) {
            shouldCommit = false;

          } else if (selectedCategory === 'selectedEventBotsBets' &&
            (state.navigations.selectedEvent.id !== payload.eventId
              || (payload.backFromBot === false && payload.layFromBot === false))) {
            shouldCommit = false;

          } else if (selectedCategory === 'selectedEventBetweenUsers' &&
            (state.navigations.selectedEvent.id !== payload.eventId || (payload.backFromBot === true || payload.layFromBot === true))) {
            shouldCommit = false;

          }
        }
        if (shouldCommit) {
          if (state.trader.ticker.tickerIsFrozen) {
            state.trader.ticker.tickerBetsOnHold.push(payload);
            if (state.trader.ticker.tickerBetsOnHold.length > tickerMaxRealTimeBets) {
              state.trader.ticker.tickerBetsOnHold.shift();
            }
          } else {
            state.trader.ticker.tickerBets.push(payload);
            if (state.trader.ticker.tickerBets.length > tickerMaxRealTimeBets) {
              state.trader.ticker.tickerBetsHistorical = [];
              state.trader.ticker.tickerBets.shift();
            }
          }
        }
      })
    },
    moveOnHoldBetsToActiveTickerFeed: function (state, payload) {
      if (state.trader.ticker.tickerBetsOnHold.length >= tickerMaxRealTimeBets) {
        state.trader.ticker.tickerBets = state.trader.ticker.tickerBetsOnHold;
      } else {
        state.trader.ticker.tickerBets = state.trader.ticker.tickerBets.concat(state.trader.ticker.tickerBetsOnHold);
        if (state.trader.ticker.tickerBets.length > tickerMaxRealTimeBets) state.trader.ticker.tickerBets.splice(-tickerMaxRealTimeBets, tickerMaxRealTimeBets)
      }
      state.trader.ticker.tickerBetsOnHold = [];

    },
    //
    setBettingBotResetFlags: function (state, payload) {
      state.trader.bettingBot.bettingBotResetFlags = payload;
    },
    toggleMyBetForBettingBotMobile: function (state, payload) {
      state.trader.bettingBot.openBettingBotMobileToggler = !state.trader.bettingBot.openBettingBotMobileToggler
    },
    setBettingBotMessage: function (state, payload) {
      state.trader.bettingBot.message = payload
    },
    setMarketsListForBettingBot: function (state, payload) {
      state.trader.bettingBot.marketsForBot = {};
      payload.forEach((market) => {
        Vue.set(state.trader.bettingBot.marketsForBot, market.id, market)
      });
    },
    setBotSport: function (state, payload) {
      state.trader.bettingBot.selectedSport = payload;
    },
    setBotCategory: function (state, payload) {
      state.trader.bettingBot.selectedCategory = payload;
    },
    setBotTournament: function (state, payload) {
      state.trader.bettingBot.selectedTournament = payload;
    },
    setBotConfig: function (state, payload) {
      state.trader.bettingBot.selectedMarket = payload;
    },
    setTournamentSupportedMarkets: function (state, payload) {
      state.trader.bettingBot.marketsForTournament = {};
      payload.forEach((market) => {
        Vue.set(state.trader.bettingBot.marketsForTournament, market.id, market)
      });
    },
    setTraderSupportedMarkets: function (state, payload) {
      try {
        state.trader.bettingBot.supportedSports = payload;
        payload.forEach((sport) => {
          Vue.set(state.trader.bettingBot.supportedSportsMap, sport.id, sport);
          state.trader.bettingBot.supportedSportsMap[sport.id].supportedCategoriesMap = {};
          sport.supportedCategories.forEach((category) => {
            Vue.set(state.trader.bettingBot.supportedSportsMap[sport.id].supportedCategoriesMap, category.id, category);
            state.trader.bettingBot.supportedSportsMap[sport.id].supportedCategoriesMap[category.id].supportedTournamentsMap = {};
            category.supportedTournaments.forEach((tournament) => {
              Vue.set(state.trader.bettingBot.supportedSportsMap[sport.id].supportedCategoriesMap[category.id].supportedTournamentsMap, tournament.id, tournament);
              // state.trader.bettingBot.supportedSportsMap[sport.id].supportedCategoriesMap[category.id].supportedTournamentsMap[tournament.id].marketConfigsMap = {};
              // tournament.marketConfigs.forEach((market)=>{
              //   Vue.set(state.trader.bettingBot.supportedSportsMap[sport.id].supportedCategoriesMap[category.id].supportedTournamentsMap[tournament.id].marketConfigsMap, market.id, market)
              // })
            })
          })
        })

      } catch (e) {
        console.log(e)
      }

    },
    clearOpenBets: function (state) {
      state.bets.active.openBets = {};
      state.bets.active.betMessages = {};
      state.bets.active.betsBeingUpdated = {};
      state.bets.active.betsBeingDeleted = {};
      state.bets.active.eventsWithBets = {};
    },
    setRefocus: function (state, payload) {
      state.bets.shouldRefocus = payload;
    },
    batchedAddOpenBet: function (state, bulkPayload) {
      bulkPayload.forEach(function (payload) {
        if (typeof payload !== 'undefined') {
          if (typeof state.bets?.active?.openBets[payload.eventId] !== 'undefined' && typeof state.bets?.active?.openBets[payload.eventId][payload.id] !== 'undefined') {
            if (payload.betStatus != 'Matched' && payload.betStatus != 'Unmatched') {
              Vue.delete(state.bets?.active?.openBets, payload.id);
              payload.betType === 'Lay' ? Vue.delete(state.bets.active.openBets[payload.eventId].bets.layMap, payload.id) :
                Vue.delete(state.bets.active.openBets[payload.eventId].bets.backMap, payload.id);

              //Decrement counter of bets for event
              if (state.bets.active.eventsWithBets.hasOwnProperty(payload.eventId)) {
                let indexOfBetMatched = state.bets.active.eventsWithBets[payload.eventId].matched.indexOf(payload.id);
                let indexOfBetUnmatched = state.bets.active.eventsWithBets[payload.eventId].unmatched.indexOf(payload.id);

                indexOfBetMatched !== -1 ? state.bets.active.eventsWithBets[payload.eventId].matched.splice(indexOfBetMatched, 1) : '';
                indexOfBetUnmatched !== -1 ? state.bets.active.eventsWithBets[payload.eventId].unmatched.splice(indexOfBetUnmatched, 1) : '';
              }
            } else {
              state.bets.active.openBets[payload.eventId][payload.id] = payload;

              payload.betType === 'Lay' ? state.bets.active.openBets[payload.eventId].bets.layMap[payload.id] = payload :
                state.bets.active.openBets[payload.eventId].bets.backMap[payload.id] = payload;

              //Increment counter for bets that relate to this event
              if (!state.bets.active.eventsWithBets.hasOwnProperty(payload.eventId)) {
                Vue.set(state.bets.active.eventsWithBets, payload.eventId, {
                  matched: [],
                  unmatched: []
                });
              }
              if (payload.betStatus === 'Matched') {
                state.bets.active.eventsWithBets[payload.eventId].matched.indexOf(payload.id) === -1 ? state.bets.active.eventsWithBets[payload.eventId].matched.push(payload.id) : '';
              }
              if (payload.betStatus === 'Unmatched')
                state.bets.active.eventsWithBets[payload.eventId].unmatched.indexOf(payload.id) === -1 ? state.bets.active.eventsWithBets[payload.eventId].unmatched.push(payload.id) : '';
            }

          } else if (payload.betStatus === 'Matched' || payload.betStatus === 'Unmatched') {
            if (typeof state.bets.active.openBets[payload.eventId] === 'undefined') {
              Vue.set(state.bets.active.openBets, payload.eventId, {
                eventName: payload.eventName,
                "homeTeam": payload.homeTeam,
                "awayTeam": payload.awayTeam,
                timeStamp: payload.timeStamp,
                eventId: payload.eventId,
                bets: {
                  lay: [],
                  layMap: {},
                  back: [],
                  backMap: {}
                }
              });
            }
            //Increment counter for bets that relate to this event
            if (!state.bets.active.eventsWithBets.hasOwnProperty(payload.eventId)) {
              Vue.set(state.bets.active.eventsWithBets, payload.eventId, {
                matched: [],
                unmatched: []
              });
            }
            if (payload.betStatus === 'Matched')
              state.bets.active.eventsWithBets[payload.eventId].matched.indexOf(payload.id) === -1 ? state.bets.active.eventsWithBets[payload.eventId].matched.push(payload.id) : '';
            if (payload.betStatus === 'Unmatched')
              state.bets.active.eventsWithBets[payload.eventId].unmatched.indexOf(payload.id) === -1 ? state.bets.active.eventsWithBets[payload.eventId].unmatched.push(payload.id) : '';


            Vue.set(state.bets.active.openBets[payload.eventId], payload.id, payload);

            payload.betType === 'Lay' ? state.bets.active.openBets[payload.eventId].bets.layMap[payload.id] = payload :
              state.bets.active.openBets[payload.eventId].bets.backMap[payload.id] = payload;

          }

          if (state.bets.active.openBets[payload.eventId] && (new Date(payload.timeStamp) - new Date(state.bets.active.openBets[payload.eventId].timeStamp) > 0)) {
            state.bets.active.openBets[payload.eventId].timeStamp = payload.timeStamp;
          }

          if (state.bets.active.openBets[payload.eventId]) {
            payload.betType === 'Lay' ?
              state.bets.active.openBets[payload.eventId].bets.lay = Object.values(state.bets.active.openBets[payload.eventId].bets.layMap).sort(function (a, b) {
                if (a.marketSort !== b.marketSort) {
                  return a.marketSort - b.marketSort
                } else if (a.market !== b.market) {
                  return ('' + a.market).localeCompare(b.market)
                } else {
                  if (a.runner !== b.runner) {
                    return ('' + a.runner).localeCompare(b.runner)
                  } else {
                    if (a.odds !== b.odds) {
                      return a.odds - b.odds
                    } else {
                      if (a.betStatus === 'Unmatched' && b.betStatus === 'Matched') {
                        return 1
                      } else {
                        return 0
                        // payload.runners.forEach(runner => {
                        //   var storedRunner = state.markets[payload.eventId]?.mainMarket?.runners?.find(x => x.id == runner.id);
                        //   if (storedRunner!=null) {
                        //     storedRunner.active = runner.active;
                        //   } else {
                        //     state.markets[payload.eventId].mainMarket.runners.push(runner);
                        //   }
                        // });
                      }
                    }
                  }
                }

              }) :
              state.bets.active.openBets[payload.eventId].bets.back = Object.values(state.bets.active.openBets[payload.eventId].bets.backMap).sort(function (a, b) {
                if (a.marketSort !== b.marketSort) {
                  return a.marketSort - b.marketSort
                } else if (a.market !== b.market) {
                  return ('' + a.market).localeCompare(b.market)
                } else {
                  if (a.runner !== b.runner) {
                    return ('' + a.runner).localeCompare(b.runner)
                  } else {
                    if (a.odds !== b.odds) {
                      return a.odds - b.odds
                    } else {
                      if (a.betStatus === 'Unmatched' && b.betStatus === 'Matched') {
                        return 1
                      } else {
                        return 0
                      }
                    }
                  }
                }

              });

          }
        }
      })

    },
    batchedSetMarketVolume: function (state, bulkPayload) {
      bulkPayload.forEach(function (payload) {
        if (state.markets[payload.eventId]?.markets[payload.id] != null) {
          Vue.set(state.markets[payload.eventId].markets[payload.id], 'volume', payload.total)
        }
      });

    },
    batchedSetEventVolume: function (state, bulkPayload) {
      bulkPayload.forEach(function (payload) {
        if (state.events.eventsList[payload.tournamentId] != null && state.events.eventsList[payload.tournamentId][payload.id] != null) {
          Vue.set(state.events.eventsList[payload.tournamentId][payload.id], 'volume', payload.total)
        } else {
          Vue.set(state.events.eventsVolumeUnpaired,payload.id,payload)
        }
      });
    },
    batchedSetOrderBook: function (state, bulkPayload) {
      bulkPayload.forEach(function (payload) {
        try {
          if (state.markets[payload.eId]?.mainMarket != null && state.markets[payload.eId]?.mainMarket.runners !== 'no') {
            state.markets[payload.eId]?.mainMarket.runners.forEach(runner => {
              if (runner.id == payload.rId) {
                if (payload?.back != null) {
                  if (payload.back.length > 0 && runner.backOdds == null) {
                    Vue.set(runner, 'backOdds', payload.back)
                    //Vue.set(runner, 'backStakes', payload.back)
                  } else if (payload.back.length > 0) {
                    runner.backOdds = payload.back;
                  } else {
                    Vue.delete(runner, 'backOdds')
                    //Vue.delete(runner, 'backStakes')
                  }
                }
                if (payload?.lay != null) {
                  if (payload.lay.length > 0 && runner.layOdds == null) {
                    Vue.set(runner, 'layOdds', payload.lay)
                    //Vue.set(runner, 'layStakes', payload.lay)
                  } else if (payload.lay.length > 0) {
                    runner.layOdds = payload.lay;
                  } else {
                    Vue.delete(runner, 'layOdds')
                    //Vue.delete(runner, 'layStakes')
                  }
                }

                return;
              }
            })
          }
          if (typeof state.markets[payload.eId] !== 'undefined' && typeof state.markets[payload.eId].markets[payload.mId] !== 'undefined') {
            state.markets[payload.eId].markets[payload.mId].runners.forEach(runner => {
              if (runner.id == payload.rId) {
                if (payload?.back != null) {
                  if (payload.back.length > 0 && runner.backOdds == null) {
                    Vue.set(runner, 'backOdds', payload.back)
                    //Vue.set(runner, 'backStakes', payload.back)
                  } else if (payload.back.length > 0) {
                    runner.backOdds = payload.back;
                  } else {
                    Vue.delete(runner, 'backOdds')
                    //Vue.delete(runner, 'backStakes')
                  }
                }
                if (payload?.lay != null) {
                  if (payload.lay.length > 0 && runner.layOdds == null) {
                    Vue.set(runner, 'layOdds', payload.lay)
                    //Vue.set(runner, 'layStakes', payload.lay)
                  } else if (payload.lay.length > 0) {
                    runner.layOdds = payload.lay;
                  } else {
                    Vue.delete(runner, 'layOdds')
                    //Vue.delete(runner, 'layStakes')
                  }
                }
                return;
              }
            })

          }
        } catch (e) {
          console.log(e)
        }

      })
    },
    batchedUpdateEvents: function (state, bulkPayload) {
      bulkPayload.forEach(function (payload) {
        // @ts-ignore
        // if(Array.isArray(state.events.eventsList[payload.tournamentId])){
        //   state.events.eventsList[payload.tournamentId] = payload;
        //
        //
        // }
        // console.log(payload);
        if (true) {
          if (payload?.lastUpdate > state.lastReceivedUpdate || state.lastReceivedUpdate == null) {
            state.lastReceivedUpdate = payload?.lastUpdate;
          }
          //Check for unpaired event volume for this event. If you find one set total volume and delete from unpaired list
          if(state.events.eventsVolumeUnpaired[payload.id]){
            payload.volume = state.events.eventsVolumeUnpaired[payload.id].total
            Vue.delete(state.events.eventsVolumeUnpaired,payload.id);
          }

          if (payload.status == 'Closed') {
            if (state.events.eventsList[payload.tournamentId] != null) {
              Vue.delete(state.events.eventsList[payload.tournamentId], payload.id)
              let entryIndex = state.events.eventsListLiveFlat.findIndex((eventForTournament) => {
                return payload.id === eventForTournament.id
              })
              if (entryIndex != -1) {
                state.events.eventsListLiveFlat.splice(entryIndex, 1)
              }
            }
            Vue.delete(state.markets, payload.id)
          } else {
            if (typeof state.events.eventsList[payload.tournamentId] !== 'undefined') {
              var event = state.events.eventsList[payload.tournamentId][payload.id];
              if (event != null) {
                event.name = payload.name;
                event.homeTeam = payload.homeTeam;
                event.awayTeam = payload.awayTeam;
                event.eventType = payload.eventType;
                event.bookingStatus = payload.bookingStatus;
                event.status = payload.status;
                event.start = payload.start;
                event.end = payload.end;
                event.matchStatus = payload.matchStatus;
              } else {
                Vue.set(state.events.eventsList[payload.tournamentId], payload.id, payload);
              }


            } else {
              Vue.set(state.events.eventsList, payload.tournamentId, {})
              Vue.set(state.events.eventsList[payload.tournamentId], payload.id, payload)
            }
            state.events.eventsList.totalEvents++;
          }

          if (payload.eventType !== 'Virtual' && (payload.status === 'Live' || payload.status === 'Interrupted' || payload.status === 'Suspended' || payload.status === 'Abandoned' || payload.status === 'Ended')) {
            let entryIndex = state.events.eventsListLiveFlat.findIndex((eventForTournament) => {
              return payload.id === eventForTournament.id
            })
            if (entryIndex != -1) {
              state.events.eventsListLiveFlat[entryIndex] = payload
            } else {
              state.events.eventsListLiveFlat.push(payload)
            }
          }
          if (typeof state.streamMappingsObj[payload.remoteId] !== 'undefined' && state.streamMappingsObj[payload.remoteId].streams !== '') {
            Vue.set(state.liveCenter.eventsWithStreamId, payload.remoteId, Object.assign(payload, {streamId: state.streamMappingsObj[payload.remoteId]}))
          }
        }

        // if(typeof state.events.eventsList[payload.tournamentId][payload.id].markets === 'undefined'){
        //   state.events.eventsList[payload.tournamentId][payload.id].markets = {};
        // }
      })
    },
    batchedUpdateMarkets: function (state, bulkPayload) {
      bulkPayload.forEach(function (payload) {
        // @ts-ignore
        if (payload.isSettled) {
          if (typeof state.markets[payload.eventId] !== 'undefined') {
            Vue.delete(state.markets[payload.eventId].markets, payload.id)
          }
        } else {
          if (typeof payload.botDisabled === 'undefined') {
            payload.botDisabled = false;
          }
          if (state.markets[payload.eventId]?.markets[payload.id]?.id == payload.id) {
            var market = state.markets[payload.eventId].markets[payload.id];
            market.status = payload.status;
            market.botDisabled = payload.botDisabled;
            if (market.runners == null) {
              Vue.set(market, "runners", payload.runners)
            } else {
              payload.runners.forEach(runner => {
                var storedRunner = market.runners.find(x => x.id == runner.id);
                if (storedRunner != null) {
                  storedRunner.active = runner.active;
                  if (runner?.backOdds != null) {
                    Vue.set(storedRunner, 'backOdds', runner.backOdds);
                  }
                  if (runner?.layOdds != null) {
                    Vue.set(storedRunner, 'layOdds', runner.layOdds);
                  }
                } else {
                  market.runners.push(runner);
                }
              });
            }
          } else if (state.markets[payload.eventId] == null) {
            Vue.set(state.markets, payload.eventId, {markets: {}, hasOneActiveMarket: false});
            Vue.set(state.markets[payload.eventId].markets, payload.id, payload);
          } else {
            Vue.set(state.markets[payload.eventId].markets, payload.id, payload);
          }
          if (payload.main === true) {
            if (state.markets[payload.eventId]?.mainMarket == null || state.markets[payload.eventId]?.mainMarket?.isDummyMainMarket) {
              Vue.set(state.markets[payload.eventId], "mainMarket", payload)
            } else {
              state.markets[payload.eventId].mainMarket.status = payload.status;
              if (state.markets[payload.eventId].mainMarket.runners == null) {
                Vue.set(state.markets[payload.eventId].mainMarket, "runners", payload.runners)
              } else {
                payload.runners.forEach(runner => {
                  var storedRunner = state.markets[payload.eventId]?.mainMarket?.runners?.find(x => x.id == runner.id);
                  if (storedRunner != null) {
                    storedRunner.active = runner.active;
                  } else {
                    state.markets[payload.eventId].mainMarket.runners.push(runner);
                  }
                });
              }
            }

          }

          let hasActiveMarket = false;
          for (let marketId in state.markets[payload.eventId].markets) {
            if (state.markets[payload.eventId].markets[marketId].status != "INACTIVE") {
              hasActiveMarket = true;
              break;
            }

          }
          if (state.markets[payload.eventId]?.hasOneActiveMarket == null) {
            Vue.set(state.markets[payload.eventId], "hasOneActiveMarket", hasActiveMarket)
            //Vue.set(state.markets[payload.eventId], "totalMarkets", totalMarkets)
          } else {
            state.markets[payload.eventId].hasOneActiveMarket = hasActiveMarket
            //state.markets[payload.eventId].totalMarkets = totalMarkets
          }


          if (typeof state.markets[payload.eventId].mainMarket === 'undefined') {
            // Vue.set(state.markets[payload.eventId], "mainMarket", {
            //   runners: 'no'
            // })
            state.markets[payload.eventId].mainMarket = {
              isDummyMainMarket: true,
              runners: 'no'
            };


          }
        }

        // state.events.eventsList[payload.]
      });
    },
    setMarketPositions: function (state, payload) {
      if (state.markets[payload.eventId]?.markets[payload.id] != null) {
        for (let i in state.markets[payload.eventId].markets[payload.id]?.runners) {
          let positionForRunner = payload.positions.find((position) => {
            return state.markets[payload.eventId].markets[payload.id].runners[i].id === position.runner
          })
          if (positionForRunner)
            Vue.set(state.markets[payload.eventId].markets[payload.id].runners[i], 'amount', positionForRunner.amount)
        }
      }

    },
    //OPEN BETS//
    setIsUpdatingBet: function (state, payload) {
      if (state.bets.active.betsBeingUpdated.hasOwnProperty(payload.id)) {
        Vue.set(state.bets.active.betsBeingUpdated[payload.id], 'isUpdating', payload.isUpdating)
      }

    },
    setIsDeletingBet:function (state, payload) {
      if (!state.bets.active.betsBeingDeleted.hasOwnProperty(payload.id)) {
        Vue.set(state.bets.active.betsBeingDeleted, payload.id, {isDeleting:false})

      }
      Vue.set(state.bets.active.betsBeingDeleted[payload.id], 'isDeleting', payload.isDeletingBet)

    },
    removeIsDeletingBet:function(state,payload){
      Vue.delete(state.bets.active.betsBeingDeleted,payload)
    },
    setSelectedOpenBetFilter: function (state, payload) {
      state.bets.active.selectedFilter = payload;
    },
    removeOpenBetErrorMessageForStake: function (state, payload) {
      // if (state.bets.betslip.betMessages[payload]) {
      //   state.bets.betslip.betMessages[payload].messageType = '';
      //   state.bets.betslip.betMessages[payload].message = '';
      // }

    },
    setOpenBetMessage: function (state, payload) {
      console.log(payload.id + ' ' + payload.message);
      Vue.set(state.bets.active.betMessages, payload.id,
        {
          type: payload.type,
          message: payload.message,
          messageId: payload.messageId,
          messageType: payload.messageType
        });
    },
    addOpenBet: function (state, payload) {
      if (typeof state.bets?.active?.openBets[payload.eventId] !== 'undefined' && typeof state.bets?.active?.openBets[payload.eventId][payload.id] !== 'undefined') {
        if (payload.betStatus != 'Matched' && payload.betStatus != 'Unmatched') {
          Vue.delete(state.bets?.active?.openBets, payload.id);
          payload.betType === 'Lay' ? Vue.delete(state.bets.active.openBets[payload.eventId].bets.layMap, payload.id) :
            Vue.delete(state.bets.active.openBets[payload.eventId].bets.backMap, payload.id);

          //Decrement counter of bets for event
          if (state.bets.active.eventsWithBets.hasOwnProperty(payload.eventId)) {
            let indexOfBetMatched = state.bets.active.eventsWithBets[payload.eventId].matched.indexOf(payload.id);
            let indexOfBetUnmatched = state.bets.active.eventsWithBets[payload.eventId].unmatched.indexOf(payload.id);

            indexOfBetMatched !== -1 ? state.bets.active.eventsWithBets[payload.eventId].matched.splice(indexOfBetMatched, 1) : '';
            indexOfBetUnmatched !== -1 ? state.bets.active.eventsWithBets[payload.eventId].unmatched.splice(indexOfBetUnmatched, 1) : '';
          }
        } else {
          state.bets.active.openBets[payload.eventId][payload.id] = payload;

          payload.betType === 'Lay' ? state.bets.active.openBets[payload.eventId].bets.layMap[payload.id] = payload :
            state.bets.active.openBets[payload.eventId].bets.backMap[payload.id] = payload;

          //Increment counter for bets that relate to this event
          if (!state.bets.active.eventsWithBets.hasOwnProperty(payload.eventId)) {
            Vue.set(state.bets.active.eventsWithBets, payload.eventId, {
              matched: [],
              unmatched: []
            });
          }
          if (payload.betStatus === 'Matched') {
            state.bets.active.eventsWithBets[payload.eventId].matched.indexOf(payload.id) === -1 ? state.bets.active.eventsWithBets[payload.eventId].matched.push(payload.id) : '';
          }
          if (payload.betStatus === 'Unmatched')
            state.bets.active.eventsWithBets[payload.eventId].unmatched.indexOf(payload.id) === -1 ? state.bets.active.eventsWithBets[payload.eventId].unmatched.push(payload.id) : '';
        }

      } else if (payload.betStatus === 'Matched' || payload.betStatus === 'Unmatched') {
        if (typeof state.bets.active.openBets[payload.eventId] === 'undefined') {
          Vue.set(state.bets.active.openBets, payload.eventId, {
            eventName: payload.eventName,
            "homeTeam": payload.homeTeam,
            "awayTeam": payload.awayTeam,
            timeStamp: payload.timeStamp,
            eventId: payload.eventId,
            bets: {
              lay: [],
              layMap: {},
              back: [],
              backMap: {}
            }
          });
        }
        //Increment counter for bets that relate to this event
        if (!state.bets.active.eventsWithBets.hasOwnProperty(payload.eventId)) {
          Vue.set(state.bets.active.eventsWithBets, payload.eventId, {
            matched: [],
            unmatched: []
          });
        }
        if (payload.betStatus === 'Matched')
          state.bets.active.eventsWithBets[payload.eventId].matched.indexOf(payload.id) === -1 ? state.bets.active.eventsWithBets[payload.eventId].matched.push(payload.id) : '';
        if (payload.betStatus === 'Unmatched')
          state.bets.active.eventsWithBets[payload.eventId].unmatched.indexOf(payload.id) === -1 ? state.bets.active.eventsWithBets[payload.eventId].unmatched.push(payload.id) : '';


        Vue.set(state.bets.active.openBets[payload.eventId], payload.id, payload);

        payload.betType === 'Lay' ? state.bets.active.openBets[payload.eventId].bets.layMap[payload.id] = payload :
          state.bets.active.openBets[payload.eventId].bets.backMap[payload.id] = payload;

      }

      if (new Date(payload.timeStamp) - new Date(state.bets.active.openBets[payload.eventId].timeStamp) > 0) {
        state.bets.active.openBets[payload.eventId].timeStamp = payload.timeStamp;
      }


      payload.betType === 'Lay' ?
        state.bets.active.openBets[payload.eventId].bets.lay = Object.values(state.bets.active.openBets[payload.eventId].bets.layMap).sort(function (a, b) {
          if (a.marketSort !== b.marketSort) {
            return a.marketSort - b.marketSort
          } else if (a.market !== b.market) {
            return ('' + a.market).localeCompare(b.market)
          } else {
            if (a.runner !== b.runner) {
              return ('' + a.runner).localeCompare(b.runner)
            } else {
              if (a.odds !== b.odds) {
                return a.odds - b.odds
              } else {
                if (a.betStatus === 'Unmatched' && b.betStatus === 'Matched') {
                  return 1
                } else {
                  return 0
                  // payload.runners.forEach(runner => {
                  //   var storedRunner = state.markets[payload.eventId]?.mainMarket?.runners?.find(x => x.id == runner.id);
                  //   if (storedRunner!=null) {
                  //     storedRunner.active = runner.active;
                  //   } else {
                  //     state.markets[payload.eventId].mainMarket.runners.push(runner);
                  //   }
                  // });
                }
              }
            }
          }

        }) :
        state.bets.active.openBets[payload.eventId].bets.back = Object.values(state.bets.active.openBets[payload.eventId].bets.backMap).sort(function (a, b) {
          if (a.marketSort !== b.marketSort) {
            return a.marketSort - b.marketSort
          } else if (a.market !== b.market) {
            return ('' + a.market).localeCompare(b.market)
          } else {
            if (a.runner !== b.runner) {
              return ('' + a.runner).localeCompare(b.runner)
            } else {
              if (a.odds !== b.odds) {
                return a.odds - b.odds
              } else {
                if (a.betStatus === 'Unmatched' && b.betStatus === 'Matched') {
                  return 1
                } else {
                  return 0
                }
              }
            }
          }

        });


    },
    setBetBeingUpdated: function (state, payload) {
      if (!state.bets.active.betsBeingUpdated.hasOwnProperty(payload.id)) {
        Vue.set(state.bets.active.betsBeingUpdated, payload.id, JSON.parse(JSON.stringify(payload)))
        Vue.set(state.bets.active.betsBeingUpdated[payload.id], 'isUpdating', false)

      }
    },
    removeBetBeingUpdated: function (state, payload) {
      if (state.bets.active.betsBeingUpdated.hasOwnProperty(payload.id)) {
        Vue.delete(state.bets.active.betsBeingUpdated, payload.id)
        if (state.bets.active.betMessages[payload.id]?.messageId !== 'betUpdateSuccessful') {
          Vue.delete(state.bets.active.betMessages, payload.id)
        }
      }
    },
    setBetBeingUpdatedStake: function (state, payload) {
      // if (payload.betType === 'back') {
      state.bets.active.betsBeingUpdated[payload.position].stake = payload.stake

      // } else {
      //   state.bets.betslip.layBets[payload.position].stake = payload.stake
      // }

    },
    setBetBeingUpdatedOdds: function (state, payload) {
      // if (payload.betType === 'back') {
      state.bets.active.betsBeingUpdated[payload.position].odds = payload.odds

      // } else {
      //   state.bets.betslip.layBets[payload.position].odds = payload.odds
      // }
    },
    // setOpenBetIsValidForUpdate: function (state, payload) {
    //   if (payload.betType === 'back') {
    //     state.bets.betslip.backBets[payload.evenId].isValid = payload.isValid
    //
    //   } else {
    //     state.bets.betslip.layBets[payload.position].isValid = payload.isValid
    //   }
    // },
    // END OPEN BETS
    setBetIsValid: function (state, payload) {
      if (payload.betType === 'back') {
        state.bets.betslip.backBets[payload.position].isValid = payload.isValid

      } else {
        state.bets.betslip.layBets[payload.position].isValid = payload.isValid
      }
    },
    setIsPlacingBets: function (state, payload) {
      state.bets.betslip.isPlacingBets = payload;
    },
    setBetslipMessage: function (state, payload) {
      state.bets.betslip.message = payload
    },
    setActiveBetSection: function (state, payload) {
      state.bets.activeSection = payload;
    },
    clearAllBetsInBetslip: function (state) {
      state.bets.betslip.backBets = [];
      state.bets.betslip.layBets = [];
      state.bets.betslip.betList = [];
    },
    removeErrorMessageForStake: function (state, payload) {
      if (state.bets.betslip.betMessages[payload]) {
        state.bets.betslip.betMessages[payload].messageType = '';
        state.bets.betslip.betMessages[payload].message = '';
      }

    },
    setStakeForBet: function (state, payload) {
      if (payload.betType === 'back') {
        state.bets.betslip.backBets[payload.position].stake = payload.stake

      } else {
        state.bets.betslip.layBets[payload.position].stake = payload.stake
      }
    },
    setOddsForBet: function (state, payload) {
      if (payload.betType === 'back') {
        state.bets.betslip.backBets[payload.position].odds = payload.odds

      } else {
        state.bets.betslip.layBets[payload.position].odds = payload.odds
      }
    },
    addBetMessage: function (state, payload) {
      console.log(payload.id + ' ' + payload.message);
      Vue.set(state.bets.betslip.betMessages, payload.id,
        {
          message: payload.message,
          messageId: payload.messageId,
          messageType: payload.messageType
        });
    },
    removeStakeMessage: function (state, payload) {
      if (state.bets.betslip.betMessages[payload.id] && state.bets.betslip.betMessages[payload.id].messageType === 'temporaryRemoveOnStakeClick') {
        state.bets.betslip.betMessages[payload.id].message = '';
        state.bets.betslip.betMessages[payload.id].messageId = '';
        state.bets.betslip.betMessages[payload.id].messageType = '';
      }
    },
    removeTemporaryOnClickMessages: function (state) {
      console.log('REMOVE MESSAGE')
      for (let betId in state.bets.betslip.betMessages) {
        if (state.bets.betslip.betMessages[betId].messageType === 'temporaryOnClickRemove') {
          state.bets.betslip.betMessages[betId].message = '';
          state.bets.betslip.betMessages[betId].messageType = '';
        }
      }
      for (let openBetId in state.bets.active.betMessages) {
        if (state.bets.active.betMessages[openBetId].messageType === 'temporaryOnClickRemove') {
          state.bets.active.betMessages[openBetId].message = '';
          state.bets.active.betMessages[openBetId].type = '';
          state.bets.active.betMessages[openBetId].messageId = '';
          state.bets.active.betMessages[openBetId].messageType = '';
        }

      }

      if (state.bets.betslip.message.messagePersistence === 'temporaryOnClickRemove') {
        state.bets.betslip.message.message = '';
        state.bets.betslip.message.type = '';
      }
      if (state.trader.bettingBot.message.messagePersistence === 'temporaryOnClickRemove') {
        state.trader.bettingBot.message.message = '';
        state.trader.bettingBot.message.type = '';
      }
    },
    addBet: function (state, payload) {
      // state.bets.betslip.betList.push(payload);
      if (!state.user.isTrader) {
        state.bets.shouldRefocus = true;
        state.bets.betslip.betList.splice(0, 0, payload);
        if (payload.betType === 'back') {
          state.bets.betslip.backBets.splice(0, 0, payload);
        } else {
          state.bets.betslip.layBets.splice(0, 0, payload);
        }
        state.bets.betslip.newestBet = payload;
      }

    },
    removeBetFromBetSlip: function (state, payload) {
      // state.bets.betslip.betList.push(payload);
      if (payload.betType === 'back') {
        state.bets.betslip.backBets.splice(payload.position, 1);

      } else {
        state.bets.betslip.layBets.splice(payload.position, 1);
      }
      //TODO:add betList remove
      // state.bets.betslip.betList.find()
      state.bets.betslip.betList.splice(state.bets.betslip.betList.findIndex(function (bet) {
        return bet.refId === payload.betId
      }), 1);
    },

    setVideoError: function (state, payload) {
      state.liveCenter.streamInfo.videoError = payload
    },
    setLiveCenterEvent: function (state, payload) {
      state.liveCenter.currentView = 'lmt'
      if (payload.eventType !== 'Virtual')
      // Vue.set(state.liveCenter, 'selectedEvent', payload);
        state.liveCenter.selectedEvent = payload;

    },
    setLiveCenterActiveSection: function (state, payload) {
      state.liveCenter.currentView = payload
    },
    setEventForStreamVideo: function (state, payload) {
      state.liveCenter.streamInfo.streamId = payload.streamId
      state.liveCenter.streamInfo.rid = payload.rid
    },
    setHlsStreamUrl: function (state, payload) {
      state.liveCenter.streamInfo.hlsUrl = payload
    },
    setDashManifestStreamUrl: function (state, payload) {
      state.liveCenter.streamInfo.dashUrl = payload
    },
    setStreamMapping: function (state, payload) {
      state.streamMappings = payload;
      for (let i in payload) {
        Vue.set(state.streamMappingsObj, payload[i].rid, {streams: payload[i].streams})
        if (payload[i].streams === '') {
          Vue.set(state.streamMappingsObj[payload[i].rid], 'reason', payload[i].reason)

        }
      }
    },
    setAppIsOnline: function (state, payload) {
      state.appIsOnline = payload
    },
    setFeedStatus: function (state, payload) {
      let connected = false;
      payload.forEach((element: any) => {
        if (element.healthy) {
          connected = true;
          return;
        }
      });

      state.feedIsOnline = connected
      state.feedStatus.list = payload
    },
    setLockDown:function (state,payload){
      state.isInLockdown = payload;
    },
    setConnectedToBackend: function (state, payload) {
      state.backendConnectionEstablished = payload
    },
    setInitialStateReady: (state, payload) => {
      state.initialStateReady = payload;
    },
    setDeviceMode: (state, payload) => {
      state.deviceMode = payload
    },
    setDetachedBetsMode: (state, payload) => {
      state.navigations.shouldDetachBets = payload;
    },
    setIsMobile: (state, payload) => {
      state.isMobile = payload
    },
    setUserCurrency: (state, payload) => {
      state.userCurrency = payload.symbol;
      state.user.minimumLiability = payload.minAcceptedBetCost;
    },
    setServerStatus: (state, payload) => {
      state.serverStatus = payload?.status
    },
    setUserBalance: (state, payload) => {
      state.user.info.balance = payload
    },
    setUserInfo: (state, payload) => {
      if (payload) {
        if(payload.token && payload.token !==''){
          state.user.token = payload.token
        }
        state.user.info = payload
        state.user.isLoggedIn = true;
        if (payload.roles?.indexOf("Trader") > -1) {
          state.user.isTrader = true;
        }
      } else {
        state.user.info = {
          balance: 0,
          country: "",
          currency: "",
          email: "",
          language: "",
          partner: "",
          partnerUserId: "",
          refreshToken: "",
          token: "",
          userId: ""
        }
        state.user.isTrader = false;

        state.user.isLoggedIn = false;
      }

    },
    setMarketVolume: (state, payload) => {

      if (state.markets[payload.eventId]?.markets[payload.id] != null) {
        Vue.set(state.markets[payload.eventId].markets[payload.id], 'volume', payload.total)
      }
    },
    setEventVolume: (state, payload) => {
      if (state.events.eventsList[payload.tournamentId][payload.id] != null) {
        Vue.set(state.events.eventsList[payload.tournamentId][payload.id], 'volume', payload.total)
      }

    },
    setOrderbook: (state, payload) => {
      // if (state.back[payload.runnerId] == null) {
      //   Vue.set(state.back, payload.runnerId, payload.back)
      // } else {
      //   state.back[payload.runnerId] = payload.back
      // }
      // if (state.lay[payload.runnerId] == null) {
      //   Vue.set(state.lay, payload.runnerId, payload.lay)
      // } else {
      //   state.lay[payload.runnerId] = payload.lay
      // }
      // if(!state.initialStateReady) {
      try {
        if (state.markets[payload.eId]?.mainMarket != null && state.markets[payload.eId]?.mainMarket.runners !== 'no') {
          state.markets[payload.eId]?.mainMarket.runners.forEach(runner => {
            if (runner.id == payload.rId) {
              if (payload?.back != null) {
                if (payload.back.length > 0 && runner.backOdds == null) {
                  Vue.set(runner, 'backOdds', payload.back)
                  //Vue.set(runner, 'backStakes', payload.back)
                } else if (payload.back.length > 0) {
                  runner.backOdds = payload.back;
                } else {
                  Vue.delete(runner, 'backOdds')
                  //Vue.delete(runner, 'backStakes')
                }
              }
              if (payload?.lay != null) {
                if (payload.lay.length > 0 && runner.layOdds == null) {
                  Vue.set(runner, 'layOdds', payload.lay)
                  //Vue.set(runner, 'layStakes', payload.lay)
                } else if (payload.lay.length > 0) {
                  runner.layOdds = payload.lay;
                } else {
                  Vue.delete(runner, 'layOdds')
                  //Vue.delete(runner, 'layStakes')
                }
              }

              return;
            }
          })
        }
        if (typeof state.markets[payload.eId] !== 'undefined') {
          state.markets[payload.eId].markets[payload.mId]?.runners.forEach(runner => {
            if (runner.id == payload.rId) {
              if (payload?.back != null) {
                if (payload.back.length > 0 && runner.backOdds == null) {
                  Vue.set(runner, 'backOdds', payload.back)
                  //Vue.set(runner, 'backStakes', payload.back)
                } else if (payload.back.length > 0) {
                  runner.backOdds = payload.back;
                } else {
                  Vue.delete(runner, 'backOdds')
                  //Vue.delete(runner, 'backStakes')
                }
              }
              if (payload?.lay != null) {
                if (payload.lay.length > 0 && runner.layOdds == null) {
                  Vue.set(runner, 'layOdds', payload.lay)
                  //Vue.set(runner, 'layStakes', payload.lay)
                } else if (payload.lay.length > 0) {
                  runner.layOdds = payload.lay;
                } else {
                  Vue.delete(runner, 'layOdds')
                  //Vue.delete(runner, 'layStakes')
                }
              }
              return;
            }
          })

        }
      } catch (e) {
        console.log(e)
      }


    },
    updateMarketsStatus: (state, payload) => {
      let eventId = payload[0].eventId;
      if (state.markets[eventId]?.markets == null) {
        return;
      }
      payload.forEach(market => {
        if (state.markets[eventId]?.markets[market.id] != null) {
          state.markets[eventId].markets[market.id].status = market.status;
          if (state.markets[eventId]?.mainMarket?.id == market.id) {
            state.markets[eventId].mainMarket.status = market.status;
          }
        }


      });

      // let totalMarkets = 0
      for (let marketId in state.markets[eventId].markets) {
        if (state.markets[eventId].markets[marketId].status != "INACTIVE") {
          state.markets[eventId].hasOneActiveMarket = true;
          break;
        }
      }
      // state.markets[eventId].hasOneActiveMarket = totalMarkets > 0
      // state.markets[eventId].totalMarkets = totalMarkets
    },
    updateMarkets: (state, payload: object) => {
      // @ts-ignore
      if (true) {

        if (payload.isSettled) {
          if (typeof state.markets[payload.eventId] !== 'undefined') {
            Vue.delete(state.markets[payload.eventId].markets, payload.id)
          }
        } else {

          if (state.markets[payload.eventId]?.markets[payload.id]?.id == payload.id) {
            var market = state.markets[payload.eventId].markets[payload.id];
            market.status = payload.status;
            if (market.runners == null) {
              Vue.set(market, "runners", payload.runners)
            } else {
              payload.runners.forEach(runner => {
                var storedRunner = market.runners.find(x => x.id == runner.id);
                if (storedRunner != null) {
                  storedRunner.active = runner.active;
                  if (runner?.backOdds != null) {
                    Vue.set(storedRunner, 'backOdds', runner.backOdds);
                  }
                  if (runner?.layOdds != null) {
                    Vue.set(storedRunner, 'layOdds', runner.layOdds);
                  }
                } else {
                  market.runners.push(runner);
                }
              });
            }
          } else if (state.markets[payload.eventId] == null) {
            Vue.set(state.markets, payload.eventId, {markets: {}, hasOneActiveMarket: false});
            Vue.set(state.markets[payload.eventId].markets, payload.id, payload);
          } else {
            Vue.set(state.markets[payload.eventId].markets, payload.id, payload);
          }
          if (payload.main === true) {
            if (state.markets[payload.eventId]?.mainMarket == null || state.markets[payload.eventId]?.mainMarket?.isDummyMainMarket) {
              Vue.set(state.markets[payload.eventId], "mainMarket", payload)
            } else {
              state.markets[payload.eventId].mainMarket.status = payload.status;
              if (state.markets[payload.eventId].mainMarket.runners == null) {
                Vue.set(state.markets[payload.eventId].mainMarket, "runners", payload.runners)
              } else {
                payload.runners.forEach(runner => {
                  var storedRunner = state.markets[payload.eventId]?.mainMarket?.runners?.find(x => x.id == runner.id);
                  if (storedRunner != null) {
                    storedRunner.active = runner.active;
                  } else {
                    state.markets[payload.eventId].mainMarket.runners.push(runner);
                  }
                });
              }
            }

          }
          // if(typeof state.markets[payload.eventId].HighestPriorityMarket === 'undefined'){
          //   Vue.set(state.markets[payload.eventId], "HighestPriorityMarket", payload)
          // } else if(state.markets[payload.eventId].HighestPriorityMarket.orderId > payload.orderId || (state.markets[payload.eventId].HighestPriorityMarket.status === 'INACTIVE' && payload !=='INACTIVE' )){
          //   Vue.set(state.markets[payload.eventId], "HighestPriorityMarket", payload)
          // }

          //}
          let hasActiveMarket = false;
          for (let marketId in state.markets[payload.eventId].markets) {
            if (state.markets[payload.eventId].markets[marketId].status != "INACTIVE") {
              hasActiveMarket = true;
              break;
            }

          }
          if (state.markets[payload.eventId]?.hasOneActiveMarket == null) {
            Vue.set(state.markets[payload.eventId], "hasOneActiveMarket", hasActiveMarket)
            //Vue.set(state.markets[payload.eventId], "totalMarkets", totalMarkets)
          } else {
            state.markets[payload.eventId].hasOneActiveMarket = hasActiveMarket
            //state.markets[payload.eventId].totalMarkets = totalMarkets
          }


          if (typeof state.markets[payload.eventId].mainMarket === 'undefined') {
            // Vue.set(state.markets[payload.eventId], "mainMarket", {
            //   runners: 'no'
            // })
            state.markets[payload.eventId].mainMarket = {
              isDummyMainMarket: true,
              runners: 'no'
            };


          }
        }

      }
      // state.events.eventsList[payload.]
    },
    updateEvents: (state, payload: object) => {
      // @ts-ignore
      // if(Array.isArray(state.events.eventsList[payload.tournamentId])){
      //   state.events.eventsList[payload.tournamentId] = payload;
      //
      //
      // }
      // console.log(payload);
      if (true) {
        if (payload?.lastUpdate > state.lastReceivedUpdate || state.lastReceivedUpdate == null) {
          state.lastReceivedUpdate = payload?.lastUpdate;
        }

        if (payload.status == 'Closed') {
          if (state.events.eventsList[payload.tournamentId] != null) {
            Vue.delete(state.events.eventsList[payload.tournamentId], payload.id)
            let entryIndex = state.events.eventsListLiveFlat.findIndex((eventForTournament) => {
              return payload.id === eventForTournament.id
            })
            if (entryIndex != -1) {
              state.events.eventsListLiveFlat.splice(entryIndex, 1)
            }
          }
          Vue.delete(state.markets, payload.id)
        } else {
          if (typeof state.events.eventsList[payload.tournamentId] !== 'undefined') {
            var event = state.events.eventsList[payload.tournamentId][payload.id];
            if (event != null) {
              event.name = payload.name;
              event.homeTeam = payload.homeTeam;
              event.awayTeam = payload.awayTeam;
              event.eventType = payload.eventType;
              event.bookingStatus = payload.bookingStatus;
              event.status = payload.status;
              event.start = payload.start;
              event.end = payload.end;
              if (payload.matchStatus != null) {
                event.matchStatus = payload.matchStatus;
              }
            } else {
              Vue.set(state.events.eventsList[payload.tournamentId], payload.id, payload);
            }


          } else {
            Vue.set(state.events.eventsList, payload.tournamentId, {})
            Vue.set(state.events.eventsList[payload.tournamentId], payload.id, payload)
          }
          state.events.eventsList.totalEvents++;
        }

        if (payload.eventType !== 'Virtual' && (payload.status === 'Live' || payload.status === 'Interrupted' || payload.status === 'Suspended' || payload.status === 'Abandoned' || payload.status === 'Ended')) {
          let entryIndex = state.events.eventsListLiveFlat.findIndex((eventForTournament) => {
            return payload.id === eventForTournament.id
          })
          if (entryIndex != -1) {
            state.events.eventsListLiveFlat[entryIndex] = payload
          } else {
            state.events.eventsListLiveFlat.push(payload)
          }
        }
        if (typeof state.streamMappingsObj[payload.remoteId] !== 'undefined' && state.streamMappingsObj[payload.remoteId].streams !== '') {
          Vue.set(state.liveCenter.eventsWithStreamId, payload.remoteId, Object.assign(payload, {streamId: state.streamMappingsObj[payload.remoteId]}))
        }
      }

      // if(typeof state.events.eventsList[payload.tournamentId][payload.id].markets === 'undefined'){
      //   state.events.eventsList[payload.tournamentId][payload.id].markets = {};
      // }
    },
    initializeNavigation: (state, payload) => {
      for (let j in payload.navigation.sports) {
        for (let i in payload.navigation.sports[j].categories) {
          payload.navigation.sports[j].categories[i].isSelected = false;

        }
        for (let i in payload.navigation.sports[j].tournaments) {
          payload.navigation.sports[j].tournaments[i].isSelected = false;

        }
      }

      // Vue.set(state.navigations, 'sports', payload.sports)
      wsConnection = payload.ws;
      state.navigations.sports = payload.navigation.sports;
    },
    updateNavigation: (state, payload) => {
      for (let j in payload.sports) {

        var foundIndex = state.navigations.sports.findIndex(x => x.id == payload.sports[j].id);
        //console.log(foundIndex);
        if (foundIndex > -1) {
          state.navigations.sports[foundIndex].liveNow = payload.sports[j].liveNow;

          state.navigations.sports[foundIndex].tournaments = payload.sports[j].tournaments;

          state.navigations.sports[foundIndex].categories = payload.sports[j].categories;
        }
      }

    },
    setIsChoosingLeaguesMobile: (state, payload) => {
      state.navigations.isChoosingLeaguesMobile = payload;
    },
    setSelectedSport: (state, payload) => {
      if (payload !== 'none') {
        state.navigations.selectedSport = payload.name;
        state.navigations.selectedSportData = payload;
        state.navigations.selectedSportTopTournaments = payload.tournaments.filter((tournament: any) => {
          return tournament.promoted === true;
        });
        state.navigations.selectedSportTopCategories = payload.categories.filter((category: any) => {
          return category.promoted === true;
        });
        state.navigations.mobileDialogPayloads.categories = JSON.parse(JSON.stringify(payload.categories));
        state.navigations.mobileDialogPayloads.tournaments = JSON.parse(JSON.stringify(payload.tournaments));


      } else {
        state.navigations.selectedSport = 'none';
        state.navigations.selectedSportData = 'none';
        state.navigations.selectedSportTopTournaments = [];
        state.navigations.selectedSportTopCategories = [];
        state.navigations.mobileDialogPayloads.category = 'none';
        state.navigations.mobileDialogPayloads.tournament = 'none';
      }
      state.navigations.selectedCategory = 'none';
      state.navigations.selectedTournament = 'none';

    },
    setSelectedCategory: (state, payload) => {
      //Select all tournaments
      state.navigations.selectedCategory = payload;
      state.navigations.selectedTournament = 'none';


    },
    resubscribeForEventMarkets: (state, payload) => {
      wsConnection.invoke("SubscribeEventAllMarkets", payload.id);
    },
    setSelectedEvent: (state, payload) => {
      console.log(payload)
      if (payload !== 'none') {
        wsConnection.invoke("SubscribeEventAllMarkets", payload.id);
        state.navigations.selectedEvent = payload;
      } else if (state.navigations.selectedEvent !== 'none') {


        var eventId = state.navigations.selectedEvent.id;

        var betslipMarkets = [];
        for (var betId in state.bets?.active?.openBets[eventId]) {
          var marketId = state.bets.active?.openBets[eventId][betId]?.marketId;
          if ((state.bets.active?.openBets[eventId][betId]?.betStatus == "Unmatched" || state.bets.active?.openBets[eventId][betId]?.betStatus == "Matched") && betslipMarkets.indexOf(marketId) == -1) {
            betslipMarkets.push(marketId);
          }
        }
        for (var market in state.bets?.betslip.betList) {
          var marketId = state.bets.betslip.betList[market]?.marketId;
          if (betslipMarkets.indexOf(marketId) == -1) {
            betslipMarkets.push(marketId);
          }
        }

        var firstRecord = true;
        var isInBetslip = false;
        if (state.markets[eventId]?.markets != null) {
          for (var marketId in state.markets[eventId].markets) {
            //var betslip = state.bets.betslip.betList.find(u=>u.marketId==marketId);
            if (!firstRecord && !state.markets[eventId].markets[marketId].main) {
              //console.log(Number(marketId) + " - " + betslipMarkets.indexOf(Number(marketId)));
              if (betslipMarkets.indexOf(Number(marketId)) == -1) {
                Vue.delete(state.markets[eventId].markets, marketId);
              } else if (!isInBetslip) {
                isInBetslip = true;
              }
            }
            firstRecord = false;
          }
        }

        if (!isInBetslip) {
          console.log('UNSUBSCRIBING')
          wsConnection.invoke("UnsubscribeEventAllMarkets", eventId);
        } else {
          console.log('UNSUBSCRIBING')
          wsConnection.invoke("UnsubscribeEventAllMarketsOddsOnly", eventId);
        }

        // wsConnection.invoke("UnsubscribeEventAllMarketsOddsOnly", eventId);

        state.navigations.selectedEvent = payload;

      }
      if (state.navigations.selectedEvent !== 'none') {
        let competitionsArray = [];

        state.navigations.sports.forEach((sport) => competitionsArray = competitionsArray.concat(sport.tournaments));
        let tournamentOfEvent = competitionsArray.find(tournament => tournament.id === payload.tournamentId);

        Vue.set(state.navigations.selectedEvent, 'sportIdentifier', tournamentOfEvent?.sportIdentifier);
        Vue.set(state.navigations.selectedEvent, 'sportId', tournamentOfEvent?.sportId);
        Vue.set(state.navigations.selectedEvent, 'categoryId', tournamentOfEvent?.categoryId);

      }

      window.deleteSelectedEvent = function () {
        Vue.delete(state.events.eventsList[payload.tournamentId], payload.id)
        Vue.delete(state.markets, payload.id)
      }

    },
    setSelectedTournament: (state, payload) => {
      state.navigations.selectedCategory = 'none';
      state.navigations.selectedTournament = payload;


    },
    setSelectedCategoryMobile: (state, payload) => {
      state.navigations.mobileDialogPayloads.tournament = 'none';
      state.navigations.mobileDialogPayloads.category = payload;

    },
    setSelectedTournamentMobile: (state, payload) => {
      state.navigations.mobileDialogPayloads.category = 'none';
      state.navigations.mobileDialogPayloads.tournament = payload;
    },
    resetMobileFiltersState: (state, payload) => {
      state.navigations.mobileDialogPayloads.category = 'none';
      state.navigations.mobileDialogPayloads.tournament = 'none'
    },
    setTimeFilter: (state, payload) => {
      state.navigations.timeframe = payload;
    },
    resetAllFiltersForSport: (state, payload) => {
      if (typeof payload !== 'undefined') {
        state.navigations.sport = payload.name
        state.navigations.sportdata = payload
      }
      state.navigations.selectedCategory = 'none';
      state.navigations.selectedTournament = 'none';
    },
    setSelectionsForFilters: (state, payload) => {
      state.navigations.selectedCategory = state.navigations.mobileDialogPayloads.category;
      state.navigations.selectedTournament = state.navigations.mobileDialogPayloads.tournament;
    },

    setHasData: function (state, payload) {
      window.location.hash = JSON.stringify({
        sport: state.navigations.selectedSportData.id,
        eventId: (state.navigations.selectedEvent !== 'none' ? state.navigations.selectedEvent.id : 'none'),
        tournamentIdForEvent: (state.navigations.selectedEvent !== 'none' ? state.navigations.selectedEvent.tournamentId : 'none'),
        tournament: (state.navigations.selectedTournament !== 'none' ? state.navigations.selectedTournament.id : 'none'),
        category: (state.navigations.selectedCategory !== 'none' ? state.navigations.selectedCategory.id : 'none'),
        categoryIdForTournament: (state.navigations.selectedTournament !== 'none' ? state.navigations.selectedTournament.categoryId : 'none'),
        sportIdForTournament: (state.navigations.selectedTournament !== 'none' ? state.navigations.selectedTournament.sportId : 'none'),
        sportIdForCategory: (state.navigations.selectedCategory !== 'none' ? state.navigations.selectedCategory.sportId : 'none')
      })
      window.triggeredHash = true;
      console.log('set hash TRUE')
    },
    updateBetslipBets: function (state, payload) {
      let allBets = [];
      let betsWithErrors = [];
      let backBetsWithErrors = [];
      let layBetsWithErrors = [];
      let backBets = state.bets.betslip.backBets;
      let layBets = state.bets.betslip.layBets;
      let newBackBets = [];
      let newLaybets = [];

      for (let iB in backBets) {
        let currentBet = payload.find((bet) => {
          return bet.refId === backBets[iB].refId
        })

        if ((typeof currentBet !== 'undefined' && currentBet.hasOwnProperty('errorCode'))) {
          newBackBets.push(backBets[iB])
          backBetsWithErrors.push(backBets[iB])
          if (currentBet.errorCode === 'InsufficientBalance') {
            Vue.set(state.bets.betslip.betMessages, currentBet.refId,
              {
                message: i18n.t(`bets.errorMessages.InsufficientBalance`) + ` (${this.userCurrency}${window.numberWithCommas(state.user.info.balance)}).`,
                messageType: 'temporaryOnClickRemove'
              });
          }  else if( currentBet.errorCode === 'InvalidFeedState'){
            Vue.set(state.bets.betslip.betMessages, currentBet.refId,
              {
                message: i18n.t(`bets.errorMessages.backendCodes.InvalidFeedState`),
                messageType: 'temporaryOnClickRemove'
              });
          }else if( currentBet.errorCode === 'EmergencyLocked'){
            Vue.set(state.bets.betslip.betMessages, currentBet.refId,
              {
                message: i18n.t(`bets.errorMessages.backendCodes.EmergencyLocked`),
                messageType: 'temporaryOnClickRemove'
              });
          }else if( currentBet.errorCode === 'WageringRequirementsForPendingBonuses'){
            Vue.set(state.bets.betslip.betMessages, currentBet.refId,
              {
                message: i18n.t(`bets.errorMessages.backendCodes.WageringRequirementsForPendingBonusesPlace`),
                messageType: 'temporaryOnClickRemove'
              });
          }else if (currentBet.errorCode !== 'RunnerInactive' &&
            currentBet.errorCode !== 'MarketInactive' &&
            currentBet.errorCode !== 'InvalidFeedState') {
            Vue.set(state.bets.betslip.betMessages, currentBet.refId,
              {
                message: i18n.t(`bets.errorMessages.invalidBetData`),
                messageType: 'temporaryOnClickRemove'
              })
          }
        } else if (backBets[iB].isValid === false) {
          newBackBets.push(backBets[iB])
          backBetsWithErrors.push(backBets[iB])
        } else if (typeof currentBet === 'undefined') {
          newBackBets.push(backBets[iB])

        }
      }
      for (let iL in layBets) {
        let currentBet = payload.find((bet) => {
          return bet.refId === layBets[iL].refId
        })

        if (((typeof currentBet !== 'undefined' && currentBet.hasOwnProperty('errorCode')))) {

          newLaybets.push(layBets[iL])
          layBetsWithErrors.push(layBets[iL])
          if (currentBet.errorCode === 'InsufficientBalance') {
            Vue.set(state.bets.betslip.betMessages, currentBet.refId,
              {
                message: i18n.t(`bets.errorMessages.backendCodes.InsufficientBalance`) + ` (${this.userCurrency}${window.numberWithCommas(state.user.info.balance)}).`,
                messageType: 'temporaryOnClickRemove'
              });
          }  else if( currentBet.errorCode === 'InvalidFeedState'){
            Vue.set(state.bets.betslip.betMessages, currentBet.refId,
              {
                message: i18n.t(`bets.errorMessages.backendCodes.InvalidFeedState`),
                messageType: 'temporaryOnClickRemove'
              });
          }else if( currentBet.errorCode === 'EmergencyLocked'){
            Vue.set(state.bets.betslip.betMessages, currentBet.refId,
              {
                message: i18n.t(`bets.errorMessages.backendCodes.EmergencyLocked`),
                messageType: 'temporaryOnClickRemove'
              });
          } else if (currentBet.errorCode === 'OtherException') {
            Vue.set(state.bets.betslip.betMessages, currentBet.refId,
              {
                message: i18n.t(`bets.errorMessages.backendCodes.OtherException`),
                messageType: 'temporaryOnClickRemove'
              })
          } else if( currentBet.errorCode === 'WageringRequirementsForPendingBonuses'){
            Vue.set(state.bets.betslip.betMessages, currentBet.refId,
              {
                message: i18n.t(`bets.errorMessages.backendCodes.WageringRequirementsForPendingBonusesPlace`),
                messageType: 'temporaryOnClickRemove'
              });
          }else if (currentBet.errorCode !== 'RunnerInactive' &&
            currentBet.errorCode !== 'MarketInactive' &&
            currentBet.errorCode !== 'InvalidFeedState') {
            Vue.set(state.bets.betslip.betMessages, currentBet.refId,
              {
                message: i18n.t(`bets.errorMessages.invalidBetData`),
                messageType: 'temporaryOnClickRemove'
              })
          }
        } else if (layBets[iL].isValid === false) {
          newLaybets.push(layBets[iL])
          layBetsWithErrors.push(layBets[iL])
        } else if (typeof currentBet === 'undefined') {
          newLaybets.push(layBets[iL])
        }
      }

      allBets = state.bets.betslip.betList;
      betsWithErrors = layBetsWithErrors.concat(backBetsWithErrors)


      if ((betsWithErrors.length > 0 && allBets.length > 0 && betsWithErrors.length !== allBets.length)) {
        state.bets.betslip.message = {
          type: 'warning',
          message: i18n.t('bets.someBetsSuccessful.message', {betsNumber: allBets.length - betsWithErrors.length}),
          messagePersistence: "temporaryOnClickRemove"
        }
      } else if (betsWithErrors.length === 0 && allBets.length > 0) {
        state.bets.betslip.message = {
          type: 'success',
          message: i18n.t('bets.allBetsSuccessful'),
          messagePersistence: "temporaryOnClickRemove"
        }

      }
      state.bets.betslip.layBets = newLaybets;
      state.bets.betslip.backBets = newBackBets;
      state.bets.betslip.betList = newLaybets.concat(newBackBets);

    },
    applyValidationFlagsForBets: function (state, payload) {

      payload.back.forEach(function (bet) {
        for (let bI in state.bets.betslip.backBets) {
          if (state.bets.betslip.backBets[bI].refId === bet.refId) {
            state.bets.betslip.backBets[bI].isValid = bet.isValid;
          }
        }
      });
      payload.lay.forEach(function (bet) {
        for (let bI in state.bets.betslip.layBets) {
          if (state.bets.betslip.layBets[bI].refId === bet.refId) {
            state.bets.betslip.layBets[bI].isValid = bet.isValid;
          }
        }
      });

    },
    /**
     * Settled bets
     */
    setSettledBets: function (state, payload) {
      state.bets.settled.betsList = payload;
    },
    setTimeFilterFrom: function (state, payload) {
      state.bets.settled.timeSelectedFrom = payload;
    },
    setTimeFilterTo: function (state, payload) {
      state.bets.settled.timeSelectedTo = payload;
    },
    setSettledBetsLoadingState: function (state, payload) {
      state.bets.settled.isLoading = payload;
    },
    /**
     * Trader
     */
    setTraderActiveSection: function (state, payload) {
      state.trader.activeSection = payload;
    },
    /**
     * Settled Markets
     */
    setSettledMarketsFromDate: function (state, payload) {
      state.trader.settledMarkets.from = payload;
    },
    setSettledMarketsToDate: function (state, payload) {
      state.trader.settledMarkets.to = payload;
    },
    setSettledMarketsList: function (state, payload) {
      state.trader.settledMarkets.settledMarketsList = payload;
    },
    setSettledMarketsLoadingState: function (state, payload) {
      state.trader.settledMarkets.isLoading = payload;
    },

  },
  actions: {
    toggleBotForEvent:function (store,payload){
      Axios.post(process.env.VUE_APP_BACKEND_URL as string + `/Admin/toggleBotForEvent/${payload.id}`,
        {
          timeout: 20 * 1000
        }) .then(function (response) {

        console.log(response)

      }.bind(store))
        .catch(function (error) {
          store.commit('setAlertMessage', payload.mode === 'on' ? 'toggleOnBotFailure' : 'toggleOffBotFailure')
          console.log(error);

        }.bind(store))

    },
    getMarketBotConfig: function (store, payload) {
      Axios.get(process.env.VUE_APP_BACKEND_URL as string + `/Admin/GetSupportedMarket/${payload}`, {}).then(function (response) {
        store.commit('setBotConfig', response.data)
      }).catch(function (error) {
        // handle error
        store.commit('setBotConfig', 'none');
        store.commit('setBettingBotMessage', {
          type: 'error',
          messageId: 'BetError',
          message: i18n.t('trader.bettingBot.unexpectedErrorOnly'),
          messagePersistence: "temporaryOnClickRemove"

        })

        console.log(error);
      })

    },
    getMarketBotConfigSilent: function (store, payload) {
      Axios.get(process.env.VUE_APP_BACKEND_URL as string + `/Admin/GetSupportedMarket/${payload}`, {}).then(function (response) {
        store.commit('setBotConfig', response.data)
      }).catch(function (error) {
        // handle error

        console.log(error);
      })

    },
    resetBot: function (store, payload) {
      if (window.navigator.onLine) {

        Axios.post(process.env.VUE_APP_BACKEND_URL as string + `/Admin/BotResetSeed?Id=${payload.marketId}`,
          {
            timeout: 20 * 1000
          })
          .then(function (response) {
            store.commit('setBettingBotMessage', {
              type: 'success',
              messageId: 'BotUpdateSuccess',
              message: i18n.t('trader.bettingBot.actionSuccess'),
              messagePersistence: "temporaryOnClickRemove"

            })
            store.dispatch('getBotSupportedMarkets')
            store.commit('setBotConfig', response.data)
            if (store.state.navigations.selectedEvent !== 'none') {

              store.dispatch('getSupportedMarketsForTournament', store.state.navigations.selectedEvent.tournamentId)
            }
            console.log(response)
          }.bind(store))
          .catch(function (error) {
            store.commit('setBettingBotMessage', {
              type: 'error',
              messageId: 'BetError',
              message: error.code === 'ECONNABORTED' ? i18n.t('trader.bettingBot.actionOutcomeUnknown') : i18n.t('trader.bettingBot.unexpectedError'),
              messagePersistence: "temporaryOnClickRemove"

            })
            console.log(error);

          }.bind(store));
      } else {
        store.commit('setBettingBotMessage', {
          type: 'error',
          messageId: 'BetError',
          message: i18n.t('trader.bettingBot.actionFailed'),
          messagePersistence: "temporaryOnClickRemove"

        })

      }

    },
    updateBot: function (store, payload) {
      if (window.navigator.onLine) {

        Axios.post(process.env.VUE_APP_BACKEND_URL as string + `/Admin/UpdateBotConfig`,
          payload, {
            timeout: 20 * 1000
          })
          .then(function (response) {
            store.commit('setBettingBotMessage', {
              type: 'success',
              messageId: 'BotUpdateSuccess',
              message: i18n.t('trader.bettingBot.actionSuccess'),
              messagePersistence: "temporaryOnClickRemove"

            })
            store.dispatch('getBotSupportedMarkets')
            store.commit('setBettingBotResetFlags', true);
            store.commit('setBotConfig', response.data)
            if (store.state.navigations.selectedEvent !== 'none') {
              store.dispatch('getSupportedMarketsForTournament', store.state.navigations.selectedEvent.tournamentId)
            }

            console.log(response)
          }.bind(store))
          .catch(function (error) {
            store.commit('setBettingBotMessage', {
              type: 'error',
              messageId: 'BetError',
              message: error.code === 'ECONNABORTED' ? i18n.t('trader.bettingBot.actionOutcomeUnknown') : i18n.t('trader.bettingBot.unexpectedError'),
              messagePersistence: "temporaryOnClickRemove"

            })
            console.log(error);

          }.bind(store))
          .then(function () {
            // store.commit('setIsUpdatingBet', {id: payload.betId, isUpdating: false})

            // always executed
          }.bind(store));
      } else {
        store.commit('setBettingBotMessage', {
          type: 'error',
          messageId: 'BetError',
          message: i18n.t('trader.bettingBot.actionFailed'),
          messagePersistence: "temporaryOnClickRemove"

        })

      }
    },
    getSupportedMarketsForBettingBot: function (store, payload) {
      Axios.get(process.env.VUE_APP_BACKEND_URL as string + `/Admin/GetSupportedMarketsForTournament/${payload}`, {}).then(function (response) {
        store.commit('setMarketsListForBettingBot', response.data)
        store.commit('setBotConfig', 'none')
      }).catch(function (error) {
        // handle error
        store.commit('setBotConfig', 'none');
        store.commit('setBettingBotMessage', {
          type: 'error',
          messageId: 'BetError',
          message: i18n.t('trader.bettingBot.unexpectedErrorOnly'),
          messagePersistence: "temporaryOnClickRemove"

        })

        console.log(error);
      })
    },
    //For polling Updates only
    getSupportedMarketsForTournament: function (store, payload) {
      Axios.get(process.env.VUE_APP_BACKEND_URL as string + `/Admin/GetSupportedMarketsForTournament/${payload}`, {}).then(function (response) {
        store.commit('setTournamentSupportedMarkets', response.data)
      }).catch(function (error) {
        // handle error
        /* This is for polling/bot buttons, so no need to show an alert under the tabs
        store.commit('setBettingBotMessage', {
          type: 'error',
          messageId: 'BetError',
          message: i18n.t('trader.bettingBot.unexpectedErrorOnly'),
          messagePersistence: "temporaryOnClickRemove"

        }) */

        console.log(error);
      })
    },
    getBotSupportedMarkets: function (store, payload) {
      Axios.get(process.env.VUE_APP_BACKEND_URL as string + `/Admin/GetSupportedMarkets`, {}).then(function (response) {
        store.commit('setTraderSupportedMarkets', response.data)

        if (store.state.trader.bettingBot.selectedSport === '') {
          store.commit('setBotSport', response.data[0].id)
        }
        if (store.state.trader.bettingBot.selectedCategory === '') {
          store.commit('setBotCategory', response.data[0].supportedCategories[0].id)
        }
        if (store.state.trader.bettingBot.selectedTournament === '') {
          store.commit('setBotTournament', response.data[0].supportedCategories[0].supportedTournaments[0].id);
          store.dispatch('getSupportedMarketsForBettingBot', response.data[0].supportedCategories[0].supportedTournaments[0].id)

        }
      }).catch(function (error) {
        // handle error
        /* This is for the indicators, so no need to show an alert under the tabs
        store.commit('setBettingBotMessage', {
          type: 'error',
          messageId: 'BetError',
          message: i18n.t('trader.bettingBot.unexpectedErrorOnly'),
          messagePersistence: "temporaryOnClickRemove"

        }) */

        console.log(error);
      })

    },
    getMarketsReport: function (store, payload) {
      let paramsPayload = {
        ...payload,
        from: store.state.trader.settledMarkets.from,
        to: store.state.trader.settledMarkets.to,
      };
      Axios.get(process.env.VUE_APP_BACKEND_URL as string + `/PartnerMarketsReport`, {
        params: paramsPayload,
        headers:
          {
            'Content-Disposition': "attachment; filename=template.xlsx",
            'Content-Type': 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
          },
        responseType: 'arraybuffer',
      })
        .then(function (response) {
          // handle success
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement('a');
          link.href = url;
          link.download = 'Markets_Export.xlsx';

          document.body.appendChild(link);

          link.click();

          document.body.removeChild(link);
          // window.URL.revokeObjectURL(link);
          store.commit('setIsDownloadingReport',false);

          console.log(response)
        })
        .catch(function (error) {
          // handle error
          store.commit('setIsDownloadingReport',false);

          console.log(error);
        })
    },
    getBetsReport: function (store, payload) {
      let paramsPayload = {
        ...payload,
        from: store.state.trader.settledMarkets.from,
        to: store.state.trader.settledMarkets.to,
      };
      Axios.get(process.env.VUE_APP_BACKEND_URL as string + `/PartnerBetsReport`, {
        headers:
          {
            'Content-Disposition': "attachment; filename=template.xlsx",
            'Content-Type': 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
          },
        responseType: 'arraybuffer',
        params: paramsPayload
      })
        .then(function (response) {
          // handle success
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement('a');
          link.href = url;
          link.download = 'Bets_Export.xlsx';

          document.body.appendChild(link);

          link.click();

          document.body.removeChild(link);
          store.commit('setIsDownloadingReport',false);

          // window.URL.revokeObjectURL(link);
          console.log(response)
        })
        .catch(function (error) {
          // handle error
          store.commit('setIsDownloadingReport',false);

          console.log(error);
        })
    },
    getSettledMarkets: function (store, payload) {
      Axios.get(process.env.VUE_APP_BACKEND_URL as string + `/PartnerSettlements`, {
        params: payload
      })
        .then(function (response) {
          // handle success
          store.commit('setSettledMarketsList', response.data)
        })
        .catch(function (error) {
          // handle error
          console.log(error);
        })
        .then(function () {
          // always executed
          store.commit('setSettledMarketsLoadingState', false)
        });

    },
    getSettledBets: function (store, payload) {
      Axios.get(process.env.VUE_APP_BACKEND_URL as string + `/Settlements`, {
        params: payload
      })
        .then(function (response) {
          // handle success
          store.commit('setSettledBets', response.data)
        })
        .catch(function (error) {
          // handle error
          console.log(error);
        })
        .then(function () {
          // always executed
          store.commit('setSettledBetsLoadingState', false)
        });

    },
    selectSportAndResetEvent: function (store, payload) {
      store.commit('setSelectedSport', payload)
      store.commit('setSelectedEvent', 'none')
    },
    resetAllFiltersForSportAndEvent: function (store, payload) {
      store.commit('resetAllFiltersForSport', payload)
      store.commit('setSelectedSport', payload)
      store.commit('setSelectedEvent', 'none')
    },
    deleteBet: function (store, payload) {
      if (window.navigator.onLine) {
        // store.commit('setIsCancellingBet', {id: payload.betId, isUpdating: true})
        Axios.post(process.env.VUE_APP_BACKEND_URL as string + `/Bets/Cancel`,
          [payload], {
            timeout: 20 * 1000
          })
          .then(function (response) {
            // handle success
            // store.commit('updateBetslipBets', response.data)
            if (response.data[0].hasOwnProperty('errorCode')) {
              store.commit('removeIsDeletingBet',payload.betId);
              if (response.data[0].errorCode === 'BetNotFound') {
                store.commit('setBetslipMessage', {
                  type: 'error',
                  message: i18n.t('bets.openBets.backendCodesDelete.BetNotFound'),
                  messagePersistence: "temporaryOnClickRemove"
                })
              } else {
                store.commit('setOpenBetMessage', {
                  id: payload.betId,
                  type: 'error',
                  message: i18n.t(`bets.openBets.backendCodesDelete.${response.data[0].errorCode}`),
                  messageType: "temporaryOnClickRemove"
                })
              }
            } else {
              /* if no error then there is nothing to show, we just wait for the ws message to delete the unmatched bet
              store.commit('setOpenBetMessage', {
                id: payload.betId,
                type: 'success',
                message: i18n.t('bets.openBets.betCancellationSuccessful'),
                messageType: "temporaryOnClickRemove"
              }) */
            }

            console.log(response)
          }.bind(store))
          .catch(function (error) {
            // handle error
            console.log(error);
            store.commit('removeIsDeletingBet',payload.betId)

            store.commit('setOpenBetMessage', {
              id: payload.betId,
              type: 'error',
              messageId: error.code === 'ECONNABORTED' ? 'networkConnectionErrorDelete' : 'unexpectedErrorDelete',
              message: error.code === 'ECONNABORTED' ? i18n.t('bets.openBets.networkConnectionError') : i18n.t('bets.openBets.unexpectedErrorDelete'),
              messageType: "temporaryOnClickRemove"
            })

          }.bind(store))
          .then(function () {
            // store.commit('setIsCancellingBet', {id: payload.betId, isUpdating: false})

            // always executed
          }.bind(store));

      } else {
        store.commit('removeIsDeletingBet',payload.betId);
        store.commit('setOpenBetMessage', {
          id: payload.betId,
          type: 'error',
          message: i18n.t('bets.openBets.noNetworkDelete'),
          messageType: "temporaryOnClickRemove"
        })

      }

    },
    updateBet: function (store, payload) {
      if (window.navigator.onLine) {
        store.commit('setIsUpdatingBet', {id: payload.betId, isUpdating: true})
        Axios.post(process.env.VUE_APP_BACKEND_URL as string + `/Bets/Update`,
          [payload], {
            timeout: 20 * 1000
          })
          .then(function (response) {
            // handle success
            // store.commit('updateBetslipBets', response.data)
            if (response.data[0].hasOwnProperty('errorCode')) {
              if (response.data[0].errorCode === 'InsufficientBalance') {
                store.commit('setOpenBetMessage', {
                  id: payload.betId,
                  type: 'error',
                  messageId: 'BetNotFound',
                  message: i18n.t(`bets.openBets.backendCodes.InsufficientBalance`) + ` (${this.userCurrency}${window.numberWithCommas(state.user.info.balance)}).`,
                  messageType: "temporaryOnClickRemove"
                })
              } else if (response.data[0].errorCode === 'BetNotFound') {
                store.commit('setBetslipMessage', {
                  type: 'error',
                  messageId: 'BetNotFound',
                  message: i18n.t('bets.openBets.backendCodes.BetNotFound'),
                  messagePersistence: "temporaryOnClickRemove"
                })
              } else {
                store.commit('setOpenBetMessage', {
                  id: payload.betId,
                  type: 'error',
                  messageId: 'BetNotFound',
                  message: i18n.t(`bets.openBets.backendCodes.${response.data[0].errorCode}`),
                  messageType: "temporaryOnClickRemove"
                })
              }
            } else {
              // store.commit('setOpenBetMessage', {
              //  id: payload.betId,
              store.commit('setBetslipMessage', {
                type: 'success',
                messageId: 'betUpdateSuccessful',
                message: i18n.t('bets.openBets.betUpdateSuccessful'),
                // messageType: "temporaryOnClickRemove"
                messagePersistence: "temporaryOnClickRemove"
              })
            }
            console.log(response)
          }.bind(store))
          .catch(function (error) {
            // handle error
            console.log(error);

            store.commit('setOpenBetMessage', {
              id: payload.betId,
              type: 'error',
              messageId: error.code === 'ECONNABORTED' ? 'networkConnectionError' : 'unexpectedError',
              message: error.code === 'ECONNABORTED' ? i18n.t('bets.openBets.networkConnectionError') : i18n.t('bets.openBets.unexpectedError'),
              messageType: "temporaryOnClickRemove"
            })

          }.bind(store))
          .then(function () {
            store.commit('setIsUpdatingBet', {id: payload.betId, isUpdating: false})

            // always executed
          }.bind(store));

      } else {
        store.commit('setOpenBetMessage', {
          id: payload.betId,
          type: 'error',
          message: i18n.t('bets.openBets.noNetwork'),
          messageType: "temporaryOnClickRemove"
        })

      }

    },
    placeBets: function (store, payload) {
      if (window.navigator.onLine) {
        store.commit('setIsPlacingBets', true)

        Axios.post(process.env.VUE_APP_BACKEND_URL as string + `/Bets/Place`,
          payload, {
            timeout: 20 * 1000
          })
          .then(function (response) {
            // handle success
            store.commit('updateBetslipBets', response.data)

            console.log(response)
          }.bind(store))
          .catch(function (error) {
            // handle error
            store.commit('setIsPlacingBets', false)
            store.commit('setBetslipMessage', {
              type: 'error',
              message: error.code === 'ECONNABORTED' ? i18n.t('bets.errorMessages.connectionError') : i18n.t('bets.errorMessages.unexpectedError'),
              messagePersistence: "temporaryOnClickRemove"
            })

          }.bind(store))
          .then(function () {
            store.commit('setIsPlacingBets', false)

            // always executed
          }.bind(store));

      } else {
        store.commit('setBetslipMessage', {
          type: 'error',
          message: i18n.t('bets.errorMessages.noNetwork'),
          messagePersistence: "temporaryOnClickRemove"
        })

      }
    },
    getStreamUrls: function (store, payload) {
      Axios.get(process.env.VUE_APP_BACKEND_URL as string + `/AV/AvailableStreams/${payload}`)
        .then(function (response) {
          // handle success
          store.commit('setStreamMapping', response.data)
        })
        .catch(function (error) {
          // handle error
          console.log(error);
        })
        .then(function () {
          // always executed
        });
    },
    getValidStreamInfo: async function (store, payload) {
      store.commit('setHlsStreamUrl', 'unset');
      store.commit('setDashManifestStreamUrl', 'unset');
      store.commit('setEventForStreamVideo', {
        rid: '',
        streamId: ''
      });
      if (typeof payload.streamId !== 'undefined') {
        let dashPromise = new Promise((res, rej) => res())
        await Promise.all([
          Axios.get(process.env.VUE_APP_BACKEND_URL as string + `/AV/Streams/${payload.streamId}/dash_manifest`).catch(function (error) {
            // handle error
            // store.commit('setVideoError', 'errorInValidStreamInfo')
            console.log(error);
          }.bind(store)),
          Axios.get(process.env.VUE_APP_BACKEND_URL as string + `/AV/Streams/${payload.streamId}/hls`).catch(function (error) {
            // handle error
            // store.commit('setVideoError', 'errorInValidStreamInfo')
            console.log(error);
          }.bind(store))

        ]).then(function (responses,) {
          store.commit('setVideoError', 'none')

          if (typeof responses[0] !== 'undefined') {
            store.commit('setHlsStreamUrl', responses[0].data.url)
          } else {
            store.commit('setHlsStreamUrl', 'unavailable')

          }
          if (typeof responses[1] !== 'undefined') {
            store.commit('setDashManifestStreamUrl', responses[1].data.url)
          } else {
            store.commit('setDashManifestStreamUrl', 'unavailable')

          }
          store.commit('setEventForStreamVideo', {
            rid: payload.event.remoteId,
            streamId: payload.streamId
          });

        }).finally(function () {
          // handle error
          if (store.state.liveCenter.streamInfo.hlsUrl === 'unavailable' && store.state.liveCenter.streamInfo.dashUrl === 'unavailable') {
            store.commit('setVideoError', 'errorInValidStreamInfo')
          }
        }.bind(store))
          .then(function () {
            // always executed
          }.bind(store))
      }
      ;

    },
    updateNavigation: function (store, payload) {
      if (typeof payload.sport !== 'undefined' && payload.sport !== 'none'
        && payload.category === 'none'
        && payload.tournament === 'none') {
        store.dispatch(
          'selectSportAndResetEvent', store.state.navigations.sports.find((sport) => {
            return payload.sport === sport.id
          }))
      }
      if ((payload.sport === 'none' || typeof payload.sport === 'undefined') && payload.category === 'none' && payload.tournament === 'none') {
        store.dispatch(
          'selectSportAndResetEvent', 'none')
      }
      if (typeof payload.category !== 'undefined' && payload.sport !== 'none' && payload.category !== store.state.navigations.selectedCategory) {
        let sportForCategory = store.state.navigations.sports.find((sport) => {
          return payload.sportIdForCategory === sport.id
        })
        store.commit('setSelectedCategory', sportForCategory ? sportForCategory.categories.find((category) => {
          return category.id === payload.category
        }) : 'none')

      }
      if (typeof payload.tournament !== 'undefined' && payload.sport !== 'none' && payload.tournament !== store.state.navigations.selectedTournament) {
        store.commit('setSelectedCategory', 'none');
        let sportForTournament = store.state.navigations.sports.find((sport) => {
          return payload.sportIdForTournament === sport.id
        })
        let tournamentSelected = sportForTournament ? sportForTournament.tournaments.find((tournament) => {
            return tournament.id === payload.tournament
          }
        ) : 'none';
        store.commit('setSelectedTournament', tournamentSelected)
      }
      if (typeof payload.eventId !== 'undefined' && payload.eventId !== 'none') {
        store.commit('setSelectedEvent', (store.state.events.eventsList[payload.tournamentIdForEvent] && store.state.events.eventsList[payload.tournamentIdForEvent][payload.eventId] ? store.state.events.eventsList[payload.tournamentIdForEvent][payload.eventId] : 'none'));
      } else {
        store.commit('setSelectedEvent', 'none');

      }
      // else {
      //   store.commit('setSelectedTournament', 'none');
      // }
    },
    getTickerBets: function (store, payload) {
      if (store.state.trader.ticker.isFetchingHistoricalBets === false) {
        store.commit('lockTickerBetFetching')
        payload.records = tickerMaxRealTimeBets;
        Axios.get(process.env.VUE_APP_BACKEND_URL as string + `/TickerHistory/`, {
          params: payload
        }).then(function (response) {
          if (response.data.length < tickerMaxRealTimeBets) {
            store.commit('setTickerHasMoreBets', false)
          } else {
            store.commit('setTickerHasMoreBets', true)
          }
          store.commit('setTickerBetEntries', response.data)
          store.commit('unlockTickerBetFetching')

        }).catch(function (error) {
          // handle error
          store.commit('unlockTickerBetFetching')

          console.log(error);
        })


      }

    },
    calculateLiability: function (store, payload) {
      Axios.post(process.env.VUE_APP_BACKEND_URL as string + `/Bets/CalculateLiability`, payload, {
        timeout: 20 * 1000
      }).then(function (response) {
        store.commit('setCalculatedLiability', response.data.liability)
        store.commit('setUserBalance', response.data.userBalance)
        store.commit('setIsCalculatingLiability', false)

      }).catch(function (error) {
        // handle error
        clearTimeout(liabilityTimeout)
        liabilityTimeout = setTimeout(function () {
          if(store.state.backendConnectionEstablished  === true && store.state.bets.betslip.betList.length > 0){
            store.dispatch('calculateLiability',payload)
            // store.commit('setIsCalculatingLiability', false)

          }
        }.bind(store,payload),1000)

        console.log(error);
      })

    }

  },
  modules: {},
});
